// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2APL0","title":"ClientInsurance_title__29VFd","itemText":"ClientInsurance_itemText__jSqd7"};